import React from 'react';
import background from '../../../../../themes/2bap/images/2bap-login-bg.svg';
import awards from '../../../../../themes/2bap/images/awards.png';
import Version from 'component/baseUI/version';
import { OrganisationLogoBlock } from '../../../../component/OrganisationLogo/OrganisationLogoBlock';
import { AppLogo } from '../../../../component/AppLogo/AppLogo';

export const ToBuildAProfileLoginPageTemplate = ({ children }) => {
  return (
    <div className="esk-2bap-login-page animated fadeInDown smart-style-6">
      <OrganisationLogoBlock />
      <Version />

      <img  className="esk-2bap-login-page__bg" src={background} alt="blue-bg" />
      <div className="esk-2bap-login-page__centered">
        <div className="esk-2bap-login-page__row">
          <div className="esk-2bap-login-page__col esk-2bap-login-page__col--logo">
            <div className="esk-2bap-login-page__logo">
              <AppLogo className="esk-2bap-login-page__logo-img" />
            </div>
          </div>
          <div className="esk-2bap-login-page__col">
            <div className="esk-2bap-login-page__width">
              <div className="esk-2bap-login-page__form">

                {children}

              </div>
            </div>
          </div>
        </div>
        <div className="esk-2bap-login-page__row">
          <div className="esk-2bap-login-page__col esk-2bap-login-page__col--right">
            <div className="esk-2bap-login-page__width">
              <img className="esk-2bap-login-page__awards-img" src={awards} alt="awards" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
